// extracted by mini-css-extract-plugin
export var button = "_lm-2";
export var card = "_lm-0";
export var closeButtonContainer = "_lm-3";
export var iconContainer = "_lm-1";